import { FreespinComebackResult } from "model/freespin-comeback-result";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import FreespinWinResult from "slotworks/model/gameplay/records/results/freespin-win-result";
import Result from "slotworks/model/gameplay/records/results/result";
import { ResultBuilder } from "slotworks/server/builders/result-builder";

class SGFreespinComebackResultBuilder implements ResultBuilder {
    public filter(token: QuickfireToken): boolean {
        return token.attributes.name === "ComebackAwarded";
    }

    public build(record: FreespinRecord, qfToken: QuickfireToken, packet: QuickfireResponsePacket): Result[] {
        const comebackResult = new FreespinComebackResult();
        const fsResult = new FreespinWinResult();
        const tokens = packet.Response.Tokens.Token as QuickfireToken[];
        for (const token of tokens) {
            if (token.attributes.name === "FreeSpinsAwarded") {
                fsResult.freespinsWon = parseInt(token.attributes.value);
            }
        }
        return [comebackResult, fsResult];
    }
}

export default new SGFreespinComebackResultBuilder();
